const routes = [
    {
        path: "/administrative/documents",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            // permission: ''
        },
        component_full_path: "administrativeDocumentManagement/pages/Index"
    }
];

export default routes;
